import IndigoApi from '../communication/IndigoApi';
import { Store } from 'redux';
import State from 'store/State';
import NetworkState from 'communication/NetworkState';
import { resetStateAction } from 'store/rootActions';
import RequestProgressService from 'requestProgress/RequestProgressService';
import { ApiRequestOptions } from 'communication/ApiCallInfo';
import { LoggingService } from '@instinet-analytics/core-lib';
import { buildLogger, Logger } from '@instinet-analytics/core-lib';
import { setConnected } from 'app/store/connectivity/actions';

export interface NetworkServiceOptions {
    indigoApi: IndigoApi;
    requestProgressService: RequestProgressService;
    loggingService: LoggingService;
}

/*
 * Monitors the network and updates state if it drops
 */
export class NetworkService {
    private indigoApi: IndigoApi;
    private requestProgressService: RequestProgressService;
    private logger: Logger;
    public store: Store<State> | undefined;

    public constructor(options: NetworkServiceOptions) {
        this.indigoApi = options.indigoApi;
        this.requestProgressService = options.requestProgressService;
        this.logger = buildLogger('NetworkService', options.loggingService);
        this.indigoApi.subscribeNetworkChange((networkState: NetworkState) =>
            this.onNetworkStatusChange(networkState)
        );
    }

    public onNetworkStatusChange(networkState: NetworkState): void {
        if (!this.store) {
            throw new Error('Store is not set');
        }
        if (networkState.connected) {
            this.store.dispatch(setConnected());
        } else {
            this.logger.warn(
                'Network unavailable: resetting state',
                networkState
            );
            this.store.dispatch(
                resetStateAction({ networkDownState: networkState })
            );
        }
    }

    public async checkProxyServiceReady() {
        const apiCall = (options: ApiRequestOptions) =>
            this.indigoApi.checkReady(options);

        await this.requestProgressService.invokeAndMonitorRequest(
            'checkReady',
            apiCall
        );
    }
}
